import React, { FC } from 'react';
import hardDollars1 from '../../../assets/help/hardDollars/hard_dollars_1.png';
import hardDollars2 from '../../../assets/help/hardDollars/hard_dollars_2.png';
import hardDollars3 from '../../../assets/help/hardDollars/hard_dollars_3.png';
import hardDollars4 from '../../../assets/help/hardDollars/hard_dollars_4.png';
import hardDollars5 from '../../../assets/help/hardDollars/hard_dollars_5.png';
import hardDollars6 from '../../../assets/help/hardDollars/hard_dollars_6.png';
import hardDollars7 from '../../../assets/help/hardDollars/hard_dollars_7.png';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import { HelpAlert, HelpBody, HelpBullet, HelpImage, HelpIndent, HelpStep, HelpTitle } from './HelpElements';

const UploadContractualClaimHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('uploadContractualClaimHelp');

    return (
        <>
            <HelpTitle>{t('uploadContractualClaimHelp_Title')}</HelpTitle>
            <HelpBody>{t('uploadContractualClaimHelp_purpose')}</HelpBody>
            <HelpStep step={1}>{t('uploadContractualClaimHelp_step1')}</HelpStep>
            <HelpImage src={hardDollars1} />
            <HelpImage src={hardDollars2} />
            <HelpStep step={2}>{t('uploadContractualClaimHelp_step2')}</HelpStep>
            <HelpImage size={'small'} src={hardDollars3} />
            <HelpStep step={3}>{t('uploadContractualClaimHelp_step3_intro')}</HelpStep>
            <HelpImage size={'xlarge'} src={hardDollars4} />
            <HelpIndent>
                <HelpBullet>{t('uploadContractualClaimHelp_field_claimNumber')}</HelpBullet>
                <HelpBullet>{t('uploadContractualClaimHelp_field_contractId')}</HelpBullet>
                <HelpBullet>{t('uploadContractualClaimHelp_field_expenseType')}</HelpBullet>
                <HelpBullet>{t('uploadContractualClaimHelp_field_asin')}</HelpBullet>
                <table style={{ borderCollapse: 'collapse', fontSize: '14px', marginTop: '8px', marginLeft: '16px' }}>
                    <thead>
                        <tr>
                            <th style={{ border: '1px solid #ddd', padding: '6px' }}>{'Product Category'}</th>
                            <th style={{ border: '1px solid #ddd', padding: '6px' }}>{'US'}</th>
                            <th style={{ border: '1px solid #ddd', padding: '6px' }}>{'CA'}</th>
                            <th style={{ border: '1px solid #ddd', padding: '6px' }}>{'MX'}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'Accessory'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B09Z48TGPH'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B09Z48TGPH'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B09Z48TGPH'}</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'Alexa/EFD'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B0D6V1H9PM'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B0D6V1H9PM'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B0D6V1H9PM'}</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'Blink'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B0F3BJJ9DJ'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B0F3BCVPN2'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B0F3BHJ266'}</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'E-ink'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B0CNVCQZG1'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B0CX8XLPTV'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B0CX8Y3CMG'}</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'Ring'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B0CZVXB3XT'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B0BZWRJD79'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B0BZWRJD79'}</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'SMP'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B0CQMRKRV5'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B0F7K67DY2'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B0DVJX97PM'}</td>
                        </tr>
                        <tr>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'Tablet'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B0CVDZ7WYW'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'B0CVDRHQTW'}</td>
                            <td style={{ border: '1px solid #ddd', padding: '6px' }}>{'Not assorted'}</td>
                        </tr>
                    </tbody>
                </table>
                <HelpBullet>{t('uploadContractualClaimHelp_field_dates')}</HelpBullet>
                <HelpBullet>{t('uploadContractualClaimHelp_field_amount')}</HelpBullet>
            </HelpIndent>
            <HelpAlert>{t('uploadContractualClaimHelp_separateFiles')}</HelpAlert>
            <HelpStep step={4}>{t('uploadContractualClaimHelp_step4')}</HelpStep>
            <HelpImage src={hardDollars5} />
            <HelpStep step={5}>{t('uploadContractualClaimHelp_step5')}</HelpStep>
            <HelpImage src={hardDollars6} />
            <HelpIndent>
                <HelpBullet>{t('uploadContractualClaimHelp_statusSuccess')}</HelpBullet>
                <HelpBullet>{t('uploadContractualClaimHelp_statusError')}</HelpBullet>
            </HelpIndent>
            <HelpImage src={hardDollars7} />
        </>
    );
};

export { UploadContractualClaimHelp };
